/**
 * 标签管理
 */
import { LABELMANAGE } from '../types';

export default {
    name: `${LABELMANAGE}`,
    path: '/labelManage',
    component: () => import(/* webpackChunkName: 'labelManage' */ '@/views/labelManage/'),
    redirect: { name: `${LABELMANAGE}Index` },
    meta: {
        title: '标签设置',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${LABELMANAGE}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'labelManage' */ '@/views/labelManage/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${LABELMANAGE}Add`,
            path: 'add',
            component: () => import(/* webpackChunkName: 'labelManage' */ '@/views/labelManage/add/Add.vue'),
        },
        {
            name: `${LABELMANAGE}Detail`,
            path: 'detail',
            component: () => import(/* webpackChunkName: 'labelManage' */ '@/views/labelManage/detail/Detail.vue'),
        },
    ],
};
